import { useState } from 'react';
import { useQuery } from 'react-query';
import { getNotebookServer } from 'api/services/notebook';
import { auth, useAuthState } from 'api/services/firebase';
import useAccountStore from '../store/accountStore';

const useNotebookHostRetrieve = () => {
  const [isRefetching, setIsRefetching] = useState(false);
  const [user] = useAuthState(auth);
  const isUserAvailable = !!user;

  const setNotebookUrl = useAccountStore(
    (state) => state.setNotebookUrl,
  );

  const isNotebookAvailable = useAccountStore(
    (state) => !!state.account.notebookUrl,
  );

  const {
    data, error, isLoading, refetch,
  } = useQuery({
    queryKey: 'notebookServer',
    queryFn: async () => {
      try {
        const response = await getNotebookServer();
        return response;
      } catch (err) {
        if (isRefetching) {
          throw err;
        }
        return null;
      }
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: false,
    enabled: isUserAvailable,
    onSettled: (response, err) => {
      if (isNotebookAvailable && (err || !response)) {
        setNotebookUrl(null);
      } else if (!isNotebookAvailable) {
        if (err) {
          setNotebookUrl(null);
        } else if (response?.status === 'OFF' || response?.status === 'TURNING_ON') {
          setIsRefetching(true);
          setTimeout(() => {
            refetch(true);
          }, 5000);
        } else if (response?.status === 'ON') {
          setIsRefetching(false);
          setNotebookUrl(response.url);
        }
      }
    },
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useNotebookHostRetrieve;
